/* ==========================
fade class
========================== */
document.addEventListener('DOMContentLoaded', function () {
  function fadeInOnScroll(inClass, doneClass, autoFirst = false, stagger = 0) {
    const items = document.querySelectorAll(inClass);
    if (autoFirst && items.length > 0) {
      items[0].classList.add(doneClass);
    }
    function onScroll() {
      const winH = window.innerHeight;
      let visibleIndex = 0;
      items.forEach((item, index) => {
        if (autoFirst && index === 0) return;
        if (item.classList.contains(doneClass)) return;
        const rect = item.getBoundingClientRect();
        if (rect.top < winH * 0.8) {
          if (stagger > 0) {
            item.style.animationDelay = `${visibleIndex * stagger}s`;
            visibleIndex++;
          }
          item.classList.add(doneClass);
        }
      });
    }
    window.addEventListener('scroll', onScroll);
    onScroll();
  }
  fadeInOnScroll('.fd-in', 'fd-done', true, 0.05);
  fadeInOnScroll('.sc-in', 'sc-done', false, 0.05);
});

/* ==========================
詳細画像
========================== */
(() => {

  /* ================= 設定 ================= */
  const MOBILE_MAX = 749;
  const PAGINATION_MAX = 640;
  const AUTOPLAY_DELAY = 4000;

  const isMobile = () => window.innerWidth <= MOBILE_MAX;
  const hasPagination = () => window.innerWidth <= PAGINATION_MAX;

  function init(container) {
    if (container.dataset.ready) return;
    container.dataset.ready = '1';

    const main = container.querySelector('.main_photo');
    const thumbs = [...container.querySelectorAll('.thumbnail li')];
    if (!main || !thumbs.length) return;

    let index = 0;
    let timer = null;

    const images = [];
    const firstLi = thumbs[0];
    if (firstLi) {
      const a = firstLi.querySelector('a');
      if (a) {
        const img = document.createElement('img');
        img.src = a.href;
        img.alt = a.querySelector('img')?.alt || '';
        img.classList.add('is-active');

        main.appendChild(img);
        images.push(img);

        img.onload = () => {
          main.style.height = img.offsetHeight + 'px';
        };
      }
    }

    thumbs.slice(1).forEach(li => {
      const a = li.querySelector('a');
      if (!a) return;

      const img = document.createElement('img');
      img.src = a.href;
      img.alt = a.querySelector('img')?.alt || '';
      img.dataset.src = a.href;

      main.appendChild(img);
      images.push(img);
    });

    let pager = null;
    function buildPager() {
      if (!hasPagination()) {
        pager?.remove();
        pager = null;
        return;
      }
      if (pager) return;

      pager = document.createElement('div');
      pager.className = 'photo-pagination';

      images.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.index = i;
        dot.addEventListener('click', () => {
          show(i);
          restart();
        });
        pager.appendChild(dot);
      });

      container.appendChild(pager);
    }

    function updatePager() {
      if (!pager) return;
      [...pager.children].forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
      });
    }

    function show(i) {
      index = (i + images.length) % images.length;

      const img = images[index];
      if (!img) return;

      requestAnimationFrame(() => {
        main.style.height = img.offsetHeight + 'px';
      });

      images.forEach(el => el.classList.remove('is-active'));
      img.classList.add('is-active');

      thumbs.forEach(t => t.classList.remove('current'));
      thumbs[index].classList.add('current');

      updatePager();
    }

    buildPager();
    show(0);

    thumbs.forEach((li, i) => {
      li.querySelector('a')?.addEventListener('click', e => {
        e.preventDefault();
        show(i);
        restart();
      });
    });

    let startX = 0;
    main.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    main.addEventListener('touchend', e => {
      if (!isMobile()) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? show(index + 1) : show(index - 1);
        restart();
      }
    });

    function start() {
      stop();
      if (!isMobile()) return;
      timer = setInterval(() => {
        show(index + 1);
      }, AUTOPLAY_DELAY);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    function restart() {
      stop();
      start();
    }

    start();

    window.addEventListener('resize', () => {
      buildPager();
      restart();
    });
  }

  const observer = new MutationObserver(() => {
    document.querySelectorAll('.photo_container').forEach(init);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


/* ==========================
ギャラリー
========================== */  
(() => {
  const links = [...document.querySelectorAll('a[data-group]')];
  if (!links.length) return;

  const groups = {};
  links.forEach(a => {
    const g = a.dataset.group;
    if (!groups[g]) groups[g] = [];
    groups[g].push(a);
  });

  let images = [];
  let captions = [];
  let index = 0;
  let startX = null;

    const overlay = document.createElement('div');
    overlay.className = 'lightbox';

    const inner = document.createElement('div');
    inner.className = 'lightbox-inner';

    const frame = document.createElement('div');
    frame.className = 'lightbox-frame';

    const img = document.createElement('img');

    const caption = document.createElement('div');
    caption.className = 'lightbox-caption';

    const prev = document.createElement('button');
    prev.className = 'lightbox-nav lightbox-prev';

    const next = document.createElement('button');
    next.className = 'lightbox-nav lightbox-next';

    const close = document.createElement('button');
    close.className = 'lightbox-close';

    frame.appendChild(img);
    inner.append(frame, caption);
    overlay.append(inner, prev, next, close);
    document.body.appendChild(overlay);

  function show(i) {
  index = (i + images.length) % images.length;

  img.onload = null;
  img.classList.remove('is-landscape', 'is-portrait', 'is-active');

  img.src = images[index];
  caption.textContent = captions[index] || '';

  img.onload = () => {
    const isLandscape = img.naturalWidth >= img.naturalHeight;
    img.classList.add(
      isLandscape ? 'is-landscape' : 'is-portrait',
      'is-active'
    );
  };
}

  function open(group, i) {
    images = groups[group].map(a => a.href);
    captions = groups[group].map(a => a.dataset.caption || '');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    show(i);
  }

  function closeBox() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function nextImg() { show(index + 1); }
  function prevImg() { show(index - 1); }

  Object.keys(groups).forEach(g => {
    groups[g].forEach((a, i) => {
      a.addEventListener('click', e => {
        e.preventDefault();
        open(g, i);
      });
    });
  });

  prev.addEventListener('click', prevImg);
  next.addEventListener('click', nextImg);
  close.addEventListener('click', closeBox);

  overlay.addEventListener('click', e => {
    if (e.target === overlay) closeBox();
  });

  window.addEventListener('keydown', e => {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeBox();
    if (e.key === 'ArrowRight') nextImg();
    if (e.key === 'ArrowLeft') prevImg();
  });

  overlay.addEventListener('pointerdown', e => {
    startX = e.clientX;
  });

  overlay.addEventListener('pointerup', e => {
    if (startX === null) return;
    const diff = startX - e.clientX;
    if (Math.abs(diff) > 50) diff > 0 ? nextImg() : prevImg();
    startX = null;
  });
})();


/* ==========================
ギャラリースクロール
========================== */
(() => {

  const MIN_ITEMS = 4;
  const VISIBLE_COUNT = 3;

  function init(gallery) {

    if (gallery.dataset.carouselReady) return;

    const items = [...gallery.querySelectorAll(':scope > a')];
    if (items.length < MIN_ITEMS) return;

    gallery.dataset.carouselReady = "1";

    // ======================
    // DOM構築
    // ======================

    const viewport = document.createElement('div');
    viewport.className = 'gallery-viewport';

    const track = document.createElement('div');
    track.className = 'gallery-track';

    items.forEach(a => track.appendChild(a));

    viewport.appendChild(track);
    gallery.appendChild(viewport);

    // ナビ生成
    const prev = document.createElement('button');
    const next = document.createElement('button');

    prev.className = 'gallery-nav gallery-prev';
    next.className = 'gallery-nav gallery-next';

    prev.type = next.type = "button";

    gallery.append(prev, next);

    // ======================
    // 状態管理
    // ======================
    let index = 0;
    let itemWidth = 0;
    let maxIndex = 0;

    function calculate() {

      const first = track.querySelector('a');
      if (!first) return;

      const style = window.getComputedStyle(first);
      const width = first.getBoundingClientRect().width;
      const margin = parseFloat(style.marginRight) || 0;

      itemWidth = width + margin;

      maxIndex = Math.max(0, items.length - VISIBLE_COUNT);

      // 高さ固定
      gallery.style.height = first.getBoundingClientRect().height + 'px';

      move(index, false);
      updateNav();
    }

    function updateNav() {
      prev.classList.toggle('is-disabled', index === 0);
      next.classList.toggle('is-disabled', index === maxIndex);
    }

    function move(i, animate = true) {

      index = Math.max(0, Math.min(i, maxIndex));

      track.style.transition = animate
        ? 'transform 0.45s cubic-bezier(.22,.61,.36,1)'
        : 'none';

      track.style.transform = `translateX(${-index * itemWidth}px)`;

      updateNav();
    }

    // ======================
    // クリック
    // ======================

    prev.addEventListener('click', () => move(index - 1));
    next.addEventListener('click', () => move(index + 1));

    // ======================
    // スワイプ
    // ======================

    let startX = null;

    viewport.addEventListener('pointerdown', e => {
      startX = e.clientX;
    });

    viewport.addEventListener('pointerup', e => {
      if (startX === null) return;

      const diff = startX - e.clientX;

      if (Math.abs(diff) > 50) {
        diff > 0 ? move(index + 1) : move(index - 1);
      }

      startX = null;
    });

    // ======================
    // リサイズ対応
    // ======================

    window.addEventListener('resize', calculate);
    window.addEventListener('load', calculate);

    calculate();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.gallery-scroll').forEach(init);
  });

})();
    
    
/* ==========================
パララックス
========================== */  
document.addEventListener("DOMContentLoaded", function () {

  const elements = document.querySelectorAll(".freeze_move");
  if (!elements.length) return;

  let instances = [];

  function init() {
    instances = [];
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const winW = window.innerWidth;
    const winH = window.innerHeight;

    elements.forEach(el => {

      // スペーサー生成
      const spacer = document.createElement("div");
      spacer.style.height = "0px";
      spacer.style.pointerEvents = "none";
      el.parentNode.insertBefore(spacer, el.nextSibling);

      instances.push({
        el,
        spacer,
        frozen: false,
        top: 0,
        height: 0,
        stickRatio: el.dataset.stick !== undefined
          ? parseFloat(el.dataset.stick)
          : 0.5,
        triggerRatio: el.dataset.trigger !== undefined
          ? parseFloat(el.dataset.trigger)
          : 1,
      });
    });

    calculatePositions();
    update();

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", calculatePositions);
  }

  function calculatePositions() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    instances.forEach(obj => {
      if (obj.frozen) return;

      const rect = obj.el.getBoundingClientRect();
      obj.top = rect.top + scrollTop;
      obj.height = obj.el.offsetHeight;
    });
  }

  function update() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const winH = window.innerHeight;

    instances.forEach(obj => {
      const { el, spacer } = obj;
      const triggerLine = winH * obj.triggerRatio;

      /* ===== 固定開始 ===== */
      if (!obj.frozen && scrollY + triggerLine >= obj.top + obj.height) {
        obj.frozen = true;

        spacer.style.height = obj.height + "px";

        const rect = el.getBoundingClientRect();
        el.style.position = "fixed";
        el.style.left = rect.left + "px";
        el.style.width = rect.width + "px";

        el.style.top = (triggerLine - obj.height) + "px";

        el.classList.add("freeze-active");
      }

      /* ===== 固定解除 ===== */
      if (obj.frozen && scrollY + triggerLine < obj.top + obj.height) {
        obj.frozen = false;

        el.style.position = "";
        el.style.top = "";
        el.style.left = "";
        el.style.width = "";

        el.classList.remove("freeze-active");
        spacer.style.height = "0px";

        const rect = el.getBoundingClientRect();
        obj.top = rect.top + scrollY;
        obj.height = el.offsetHeight;
      }
    });
  }

  function handleResize() {
    calculatePositions();
    update();
  }

  window.addEventListener("load", init);
});